import {
  type FieldValues,
  type UseControllerProps,
  useController,
} from 'react-hook-form';
import { IconPicker, type IconPickerProps } from '../icon-picker/input';

type RHFIconPickerProps<TField extends FieldValues> = {
  label?: string;
  pickerProps?: IconPickerProps;
  controlProps: UseControllerProps<TField>;
};

export const RHFIconPicker = <TField extends FieldValues>({
  label,
  pickerProps,
  controlProps,
}: RHFIconPickerProps<TField>) => {
  const {
    field,
    fieldState: { error },
  } = useController(controlProps);

  return (
    <IconPicker
      {...pickerProps}
      {...field}
      value={field.value}
      label={label}
      error={!!error}
      helperText={error?.message}
    />
  );
};
